module.exports = __webpack_public_path__ + "img/P13.22ad008b.png";